import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStore } from '../../features/login/store/auth.store';
import { PATH } from '../enums/routes.enum';

export const AuthRedirectGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);

  if (authStore.isAuthenticated()) {
    authStore.navigate(PATH.REPORTS);
    return false;
  }
  return true;
};
